var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isOffline)?_c('div',{staticClass:"offline-indicator"},[_c('div',{staticClass:"offline-indicator__user-inform animated fadeInUp"},[_vm._v("\n    Wygląda na to, że jesteś offline :(\n  ")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a99b94b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/OfflineIndicator/index.vue
// module id = 995
// module chunks = 11